if (typeof HeroCarousel === 'undefined') {
    class HeroCarousel extends HTMLElement {
        constructor() {
            super();
            this.autoplayDelay = this.hasAttribute('data-autoplay-delay')
                ? parseInt(this.getAttribute('data-autoplay-delay'), 10)
                : false;
            this.swiper = null;
        }

        connectedCallback() {

            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            whenReady('Swiper', () => {
                try {
                    const modules = [Swiper.Mousewheel, Swiper.EffectFade, Swiper.A11y];
                    if (this.autoplayDelay) {
                        modules.push(Swiper.Autoplay);
                    }

                    this.swiper = new Swiper(swiperContainer, {
                        loop: true,
                        a11y: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        mousewheel: {
                            forceToAxis: true,
                            thresholdDelta: 10
                        },
                        autoplay: this.autoplayDelay
                            ? {
                                delay: this.autoplayDelay,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: false
                            }
                            : false,
                        modules
                    });

                    this.swiper.on('slideChange', () => {
                        if(this.swiper.slides[this.swiper.activeIndex].querySelector("video") !== null){
                            const video = this.swiper.slides[this.swiper.activeIndex].querySelector("video");
                            if (video) {
                                // Preserve muted state if user has previously unmuted this video
                                // Only set to muted if it hasn't been explicitly unmuted by user
                                const wasUnmuted = video.dataset.userUnmuted === 'true';
                                if (!wasUnmuted) {
                                    video.muted = true; // Muted videos have better autoplay support
                                }
                                
                                video.playsInline = true; // Prevents fullscreen on iOS
                                
                                // Try to play with a small delay to ensure DOM is ready
                                setTimeout(() => {
                                    const playPromise = video.play();
                                    if (playPromise !== undefined) {
                                        playPromise.catch(error => {
                                            // Autoplay was prevented or failed
                                            console.log('Video autoplay prevented:', error);
                                            
                                            // Try one more time with user interaction simulation
                                            // This is a last resort and may not work on all devices
                                            try {
                                                video.currentTime = 0;
                                                video.play();
                                            } catch (retryError) {
                                                console.log('Video autoplay retry failed:', retryError);
                                            }
                                        });
                                    }
                                }, 100);
                            }
                        }
                    });

                    if (this.querySelectorAll(".swiper-next-button").length) {
                        this.querySelectorAll(".swiper-next-button").forEach($button => {
                            $button.addEventListener("click", e => {
                                e.preventDefault();
                                this.swiper.slideNext();
                            });
                        });
                    }
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

    }

    if (!window.customElements.get('hero-carousel')) {
        window.customElements.define('hero-carousel', HeroCarousel);
    }
}